/**
 * What a donate block's progress bar says it has raised.
 *
 * With Stripe connected, card gifts are counted by themselves: the
 * server sends their totals (Donations::giftTotals) and the block adds
 * them to whatever the organizer typed in, which becomes the money
 * that arrived some OTHER way (PayPal, checks, an event). Without a
 * connection, or with the block's own "count card gifts" box
 * unticked, the typed numbers are the whole story, as they always
 * were.
 *
 * A block with a purpose counts only gifts made for that purpose, so
 * two campaigns on one site each fill their own bar. The key has to be
 * the text exactly as checkout stored it: trimmed and cut at 120.
 */
export function purposeKey(purpose) {
    return String(purpose || '').trim().slice(0, 120);
}

export function countsCardGifts(config, donations) {
    return !!donations?.gift_totals && config?.count_card_gifts !== false;
}

export function cardGiftTotals(config, donations) {
    const totals = donations?.gift_totals;
    if (!totals) return { raised: 0, donors: 0 };
    const key = purposeKey(config?.purpose);
    const t = key ? totals.by_purpose?.[key] : totals.all;
    return {
        raised: Math.max(0, Number(t?.raised) || 0),
        donors: Math.max(0, Math.floor(Number(t?.donors) || 0)),
    };
}

export function campaignProgress(config, donations) {
    const typedRaised = Math.max(0, Number(config?.raised) || 0);
    const typedDonors = Math.max(0, Math.floor(Number(config?.donors) || 0));
    if (!countsCardGifts(config, donations)) {
        return { raised: typedRaised, donors: typedDonors };
    }
    const card = cardGiftTotals(config, donations);
    return {
        raised: Math.round((typedRaised + card.raised) * 100) / 100,
        donors: typedDonors + card.donors,
    };
}
